import React from 'react'

/**
 * TextArea component with consistent styling
 * @param {Object} props - Component props
 * @param {string} props.value - TextArea value
 * @param {function} props.onChange - Change handler function
 * @param {string} props.placeholder - TextArea placeholder
 * @param {string} props.label - TextArea label
 * @param {boolean} props.required - Whether textarea is required
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.fullWidth - Whether textarea should take full width
 * @param {number} props.rows - Number of rows
 * @param {Object} props.rest - Additional props to pass to the textarea element
 */
const TextArea = ({
  value,
  onChange,
  placeholder,
  label,
  required = false,
  className = '',
  fullWidth = true,
  bottomGap = false,
  rows = 4,
  ...rest
}) => {
  const textareaId = `textarea-${label?.toLowerCase().replace(/\s+/g, '-') || Math.random().toString(36).substring(2, 9)}`

  // Base styles - removed margin/padding from base styles
  const baseStyles =
    'border border-gray-300 rounded focus:outline-none focus:border-green-500 focus:ring-0 transition-all duration-200'

  // Width styles
  const widthStyles = fullWidth ? 'w-full' : ''

  // Padding styles - separated from base styles
  const paddingStyles = 'px-4 py-2'

  // Container styles - only add margin when there's a label
  const containerStyles = `flex ${fullWidth ? 'w-full' : ''}`

  return (
    <div className={containerStyles}>
      {label && (
        <label htmlFor={textareaId} className="block text-gray-700 font-medium">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        id={textareaId}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        rows={rows}
        className={`mb-0 ${baseStyles} ${paddingStyles} ${widthStyles} ${className}`}
        {...rest}
      />
    </div>
  )
}

export default TextArea
